export default {
  GET_DATA_FROM_API: 'getDataFromAPI',
  GET_TEXT_FROM_API: 'getTextFromAPI',
  POST_TEXT_TO_API: 'postTextToAPI',
  SET_URL_API: 'setUrlAPI',
  GET_APP_SETTINGS_FROM_API: 'getAppSettingsFromApi',
  POST_APP_SETTINGS_TO_API: 'postAppSettingsToApi',
  SET_APP_SETTINGS_ID: 'setAppSettingsId',
  SET_APP_SETTINGS_NAME: 'setAppSettingsName',
  SET_APP_SETTINGS_LOGO_URL: 'setAppSettingsLogoUrl',
  SET_APP_SETTINGS_DOCUMENT_LIST: 'setAppSettingsDocumentList', //
  SET_APP_SETTINGS_DOCUMENT_LIST_ADD_LANGUAGE: 'setAppSettingsDocumentListAddLanguage', //
  SET_APP_SETTINGS_COLORS: 'setAppSettingsColors',
  SET_APP_SETTINGS_FONT: 'setAppSettingsFont',
  POST_APP_SETTINGS_LOGO: 'postAppSettingsLogo',
  POST_APP_SETTINGS_COLORS: 'postAppSettingsColors',
  POST_APP_SETTINGS_FONT: 'postAppSettingsFont'
}
